import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import MuiCard, { CardProps as MuiCardProps } from '@material-ui/core/Card';
import classnames from 'classnames';

const styles = ({
  custom: {
    palette: { colorLightBlue },
  },
}: Theme) =>
  createStyles({
    variantOutlined: {
      border: `1px solid ${colorLightBlue}`,
    },
  });

export interface CardProps extends Omit<MuiCardProps, 'classes'>, WithStyles<typeof styles> {
  variant?: 'outlined';
}

const Card: React.FC<CardProps> = ({ classes, className, variant, ...rest }) => (
  <MuiCard
    classes={{
      root: classnames(
        {
          [classes.variantOutlined]: variant === 'outlined',
        },
        className,
      ),
    }}
    {...rest}
  />
);

export default withStyles(styles, { name: 'LumaCard' })(Card);
